module.exports = __webpack_public_path__ + "static/media/loading.48e99bc7.gif";